import { useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import toast from "react-hot-toast";
import { IoClose } from "react-icons/io5";
import { PiCaretDownBold } from "react-icons/pi";
import Logo from "../../assets/images/Bodybon-TypeLogo.png";
import MenuIcon from "../../assets/icons/menu.svg";
import ProfileIcon from "../../assets/icons/profile.svg";
import ManAvatar from "../../assets/icons/avatar-man.png";
import WomanAvatar from "../../assets/icons/avatar-woman.png";
import { menuItems } from "../../data/Menu";
import { socials } from "../../data/Socials";
import apiClient from "../../services/apiClient";
import useStore from "../../features/store";

import SubscriptionPlan from "../../assets/icons/chat.svg";

const Drawer = () => {
  const { pathname } = useLocation();
  const drawerToggleRef = useRef<HTMLInputElement>(null);
  //@ts-ignore
  const { profile } = useStore();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  const closeDropdown = () => setIsDropdownOpen(false);

  const closeDrawer = () => {
    if (drawerToggleRef.current) {
      drawerToggleRef.current.checked = false;
    }
  };

  const handleUserLogout = async () => {
    try {
      const response = await apiClient.post("/profile/logout/");
      if (response.status === 205) {
        localStorage.clear();
        window.location.pathname = "/intro";
      }
    } catch (error) {
      toast.error("مشکلی پیش آمد");
    }
  };

  const MenuListItem = ({ menuItem }: { menuItem: any }) => {
    return (
      <li key={menuItem.title} className="py-1">
        <Link
          to={menuItem.link}
          onClick={closeDropdown}
          className={`font-bold hover:bg-gray-100 menu-link ${
            pathname === menuItem.link ? "bg-gray-100" : "bg-transparent"
          }`}
        >
          <img src={menuItem.icon} className="ml-2" alt={menuItem.title} />
          {menuItem.title}
        </Link>
      </li>
    );
  };

  return (
    <div className="drawer flex justify-end items-center">
      <div className="dropdown dropdown-end ml-2 mt-1">
        {profile && (
          <div
            tabIndex={0}
            role="button"
            onClick={toggleDropdown}
            className="btn p-0 rounded-full min-h-[10px] h-[auto] duration-300 border-[1px] border-gray-500 bg-white hover:bg-white z-[100] hover:border-gray-900"
            style={{ boxShadow: "none" }}
          >
            <div className="relative flex items-center justify-between rounded-full h-10 pr-[2.5px] pl-3 overflow-hidden">
              <div
                className={`w-9 h-9 rounded-full bg-pr_primary ${
                  profile?.gender === "UNKNOWN" ? "p-[.4rem]" : "p-0"
                }`}
              >
                <img
                  src={
                    profile?.gender === "FEMALE"
                      ? WomanAvatar
                      : profile?.gender === "MALE"
                      ? ManAvatar
                      : ProfileIcon
                  }
                  alt="پروفایل"
                  className="w-full h-full"
                />
              </div>
              <span className="mr-2 font-[700] text-[14px] font-rokh mt-1 text-black">
                {profile?.user?.first_name || ""}{" "}
                {profile?.user?.last_name || ""}
                {!profile?.user?.first_name &&
                  !profile?.user?.last_name &&
                  "کاربر بادی‌بان"}
              </span>
              <PiCaretDownBold size={14} className="mr-3 lg:mr-5 text-black" />
            </div>
          </div>
        )}
        {isDropdownOpen && (
          <Fade>
            <ul
              tabIndex={0}
              className="dropdown-content menu bg-white rounded-box z-[1] w-52 p-2 shadow mt-2"
            >
              {profile?.role === "SAD" && (
                <MenuListItem
                  menuItem={menuItems.find((item) => item.is_admin)}
                />
              )}
              {menuItems
                .filter((item) => item.profile_related && !item.is_admin)
                .map((menuItem) =>
                  menuItem.title === "خروج" ? (
                    <li key={menuItem.title} className="py-1">
                      <button
                        onClick={() => {
                          handleUserLogout();
                          closeDropdown();
                        }}
                        className="font-bold hover:bg-gray-100 active:bg-gray-300"
                      >
                        <img
                          src={menuItem.icon}
                          className="ml-2"
                          alt={menuItem.title}
                        />
                        {menuItem.title}
                      </button>
                    </li>
                  ) : (
                    <MenuListItem menuItem={menuItem} key={menuItem.title} />
                  )
                )}
            </ul>
          </Fade>
        )}
      </div>

      <input
        id="my-drawer"
        type="checkbox"
        className="drawer-toggle"
        ref={drawerToggleRef}
      />
      <div className="drawer-content">
        <label
          htmlFor="my-drawer"
          className="cursor-pointer bg-white border-[1px] border-gray-500 duration-300 hover:border-gray-900 rounded-full w-10 lg:w-11 h-10 lg:h-11 flex items-center justify-center"
        >
          <img src={MenuIcon} width={25} height={25} alt="منو" />
        </label>
      </div>
      <div className="drawer-side z-10">
        <label
          htmlFor="my-drawer"
          aria-label="close sidebar"
          className="drawer-overlay"
        ></label>
        <div className="menu bg-white min-h-full w-80 p-4 pr-2 pt-6 flex flex-col justify-between">
          <div className="flex justify-between items-center">
            <img src={Logo} width={120} alt="بادی‌بان" />
            <label
              htmlFor="my-drawer"
              className="btn w-8 h-8 p-0 btn-outline rounded-full min-h-0"
            >
              <IoClose size={20} />
            </label>
          </div>

          <div className="flex-1 pt-14">
            {menuItems
              .filter((item) =>
                profile?.role === "SAD" ? item : !item.is_admin
              )
              .map((menuItem) =>
                menuItem.title === "خروج" ? (
                  <button
                    key={menuItem.title}
                    onClick={handleUserLogout}
                    className="flex w-full items-center py-2 mb-4 pr-1 rounded-lg hover:bg-slate-100 duration-300"
                  >
                    <img
                      src={menuItem.icon}
                      className="ml-3"
                      alt={menuItem.title}
                    />
                    <h6
                      className={`font-bold text-md ${
                        pathname === menuItem.link
                          ? "text-blue-600"
                          : "text-black"
                      }`}
                    >
                      {menuItem.title}
                    </h6>
                  </button>
                ) : (
                  <Link
                    target={menuItem.is_blank ? "_blank" : "_self"}
                    key={menuItem.title}
                    to={menuItem.link}
                    className={`flex items-center py-2 mb-3 pr-1 rounded-lg hover:bg-slate-100 duration-300 ${
                      pathname === menuItem.link
                        ? "bg-slate-100"
                        : "bg-transparent"
                    }`}
                    onClick={closeDrawer}
                  >
                    <img
                      src={menuItem.icon}
                      className="ml-3"
                      alt={menuItem.title}
                    />
                    <h6
                      className={`font-bold text-md ${
                        pathname === menuItem.link
                          ? "text-blue-600"
                          : "text-black"
                      }`}
                    >
                      {menuItem.title}
                    </h6>
                  </Link>
                )
              )}
          </div>

          <div className="flex items-center justify-center gap-3 pb-5">
            {socials.map((socialItem) => (
              <a
                href={socialItem.link}
                key={socialItem.title}
                target="_blank"
                className="p-2 rounded-full w-11 h-11 hover:bg-gray-100 duration-500"
                onClick={closeDrawer}
              >
                <img src={socialItem.icon} width={28} alt={socialItem.title} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Drawer;
